import { render } from "./BalForm.vue?vue&type=template&id=05630db0"
import script from "./BalForm.vue?vue&type=script&lang=ts"
export * from "./BalForm.vue?vue&type=script&lang=ts"
script.render = render

export default script